export const LICENSES_PATHS = {
  tenantId: 'seamless',
  manifest: 'licenses/manifest/manifest.json',
};
